import React, { useState } from 'react';
import styled from 'styled-components';

type TextAreaProps = {
  onSubmit: (text: string) => void;
  update: boolean;
};

const Container = styled.div`
  margin-top: 10px;
`;

const StyledTextField = styled.textarea`
  width: 100%;
  min-height: 100px;
  max-height: 200px;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  resize: vertical;
  font-size: 16px;
  margin-bottom: 10px;

  &:focus {
    border-color: #6c757d;
  }
`;

const StyledButton = styled.button`
  font-size: 12px;
  font-weight: bold;
  text-transform: none;
  background-color: #5046e5;
  color: white;
  margin: 10px 0;
  padding: 10px;
  border: none;
  border-radius: 4px;

  &:hover {
    background-color: #6564ee;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const ErgoText = styled.div`
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TextArea = ({ onSubmit, update }: TextAreaProps) => {
  const [text, setText] = useState('');

  const handleSubmit = (text: string) => {
    onSubmit(text);
    setText('');
  };

  return (
    <Container>
      <StyledTextField
        value={text}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
          setText(event.target.value);
        }}
        onKeyDown={e => {
          if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
            if (!text) return;
            handleSubmit(text);
          }
        }}
      />
      <Footer>
        {!update || (update && text) ? (
          <StyledButton onClick={() => handleSubmit(text)}>
            {update ? 'Update' : 'Generate'}
          </StyledButton>
        ) : (
          <div></div>
        )}
        <ErgoText>{text ? 'command + enter to send' : ''}</ErgoText>
      </Footer>
    </Container>
  );
};

export default TextArea;
